import { useState, useCallback } from 'react';
import api from '../api/client';

const usePatchURL = () => {
  const [isGrabando, setGrabando] = useState(false);
  const [erroresPatch, setErroresPatch] = useState(null);

  const patchData = useCallback(async (path, datos, datosGrabados) => {
    setGrabando(true);
    setErroresPatch(null);
    try {
      const res = await api.patch(path, datos);

      if (res.ok) {
        datosGrabados(res.data ?? null);
      } else {
        setErroresPatch(res.errors ?? ['Error al actualizar los datos']);
      }
    } catch (error) {
      console.error('Error Patch', error.message ?? error);
      setErroresPatch(['Error al actualizar los datos']);
    }
    setGrabando(false);
  }, []);

  const resetErroresPatch = useCallback(() => {
    setErroresPatch(null);
  }, []);

  return { isGrabando, erroresPatch, patchData, resetErroresPatch };
};

export default usePatchURL;
